// src/components/Labs/biology/apparatus/PetriDishBase.jsx
import React from "react";
import { useDrop } from "react-dnd";
import { motion } from "framer-motion";
import { ItemTypes } from "../../../../utils/constants";

export default function PetriDishBase({ loaded, specimenName, image, onSpecimenDrop }) {
  const [{ isOver }, drop] = useDrop(
    () => ({
      accept: ItemTypes.SPECIMEN,
      drop: (item) => {
        if (onSpecimenDrop) onSpecimenDrop(item);
      },
      collect: (monitor) => ({
        isOver: monitor.isOver(),
      }),
    }),
    [onSpecimenDrop]
  );

  const src = loaded && image ? `/biology-slides/${image}` : null;

  return (
    <div className="flex flex-col items-center">
      <div className="relative w-56 h-56 flex items-center justify-center">
        <div className="absolute bottom-2 w-40 h-4 bg-black/10 rounded-full blur-md" />

        <div
          ref={drop}
          className={[
            "relative w-44 h-44 rounded-full border-[6px] border-sky-300 bg-sky-50/80 shadow-md overflow-hidden flex items-center justify-center",
            "transition-all duration-200",
            isOver ? "ring-4 ring-pink-400 scale-105" : "",
          ].join(" ")}
        >
          {!loaded || !src ? (
            <p className="text-xs text-gray-500 text-center px-2">
              Drop sample to view
            </p>
          ) : (
            <motion.img
              src={src}
              alt={specimenName}
              className="w-full h-full object-cover"
              initial={{ scale: 0.7, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ duration: 0.5 }}
            />
          )}
        </div>
      </div>

      <p className="mt-2 text-xs text-gray-700 max-w-xs text-center">
        {loaded ? specimenName : "Petri Dish"}
      </p>
    </div>
  );
}
